import React from 'react';

import {
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  BaseTier1ReturnAuthorizationModal,
  selectFields
} from 'modules/layer01';

import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();
const { genController } = selectFields.ItemSelectField.genComponentAndControllerGenerator();
const ControlledInventoryItemSelectField = genController<types.IFormState>();



export interface IProps {
  returnAuthorizationId: string;

  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [triage, triageTuple] = dataService.useTriageTier1ReturnAuthorization(props.returnAuthorizationId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      binNumber: '',
      item: {
        id: '',
        displayName: ''
      },
      technicianComment: ''
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, ['binNumber', 'item']);

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      const workflowId = queryTuple.data.triageWorkflowId;
      if (workflowId) {
        await errorUtil.errorWrap(async () => {
          await triage(workflowId, formState);
        });
        props.onFinish();
      }
    },
    [
      props,
      queryTuple.data.triageWorkflowId,
      triage
    ]
  );

  const loading = queryTuple.loading || triageTuple.loading;
  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Add to be Restocked"
      primaryText="Review and confirm to add item to be restocked"
      secondaryText="Review the item before proceeding"
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}
      disableButtons={loading}>
      <Stack>
        <ControlledTextField
          isDisabled
          label="BIN"
          fieldKey="binNumber"
          formControl={form.control} />

        <ControlledInventoryItemSelectField
          isDisabled
          label="Restock SKU"
          fieldKey="item"
          formControl={form.control} />

        <ControlledTextField
          label="Technician Comment"
          fieldKey="technicianComment"
          formControl={form.control}
          numLines={5} />
      </Stack>
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
